"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var _marketing = require("@/api/marketing");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var defaultObj = {
  image: '',
  sliderImages: [],
  videoLink: '',
  sliderImage: '',
  storeName: '',
  keyword: '',
  cateIds: [],
  // 商品分类id
  cateId: null,
  // 商品分类id传值
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  ficti: 0,
  isShow: false,
  isBenefit: false,
  isNew: false,
  isGood: false,
  isHot: false,
  isBest: false,
  tempId: '',
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    barCode: '',
    weight: 0,
    volume: 0,
    addStock: 0
  }],
  attr: [],
  selectRule: '',
  isSub: false,
  content: '',
  specType: false,
  id: 0,
  couponIds: [],
  coupons: [],
  activity: ['默认', '秒杀', '砍价', '拼团']
};
var objTitle = {
  price: {
    title: '售价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  },
  addStock: {
    title: '增加库存'
  }
};
var _default = exports.default = {
  name: 'storeEdit',
  props: ['productId'],
  data: function data() {
    return {
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 多规格
      formValidate: Object.assign({}, defaultObj),
      formThead: Object.assign({}, objTitle),
      manyTabTit: {},
      manyTabDate: {},
      attrInfo: {},
      isDisabled: true,
      tempRoute: {}
    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    },
    oneFormBatch: function oneFormBatch() {
      var obj = [Object.assign({}, defaultObj.attrValue[0])];
      delete obj[0].barCode;
      return obj;
    }
  },
  watch: {
    'formValidate.attr': {
      handler: function handler(val) {
        this.watCh(val); //重要！！！
      },
      immediate: false,
      deep: true
    }
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    if (this.formValidate.specType) {
      this.$watch('formValidate.attr', this.watCh);
    }
  },
  mounted: function mounted() {
    this.getInfo(this.productId);
  },
  methods: {
    success: function success() {
      var _this = this;
      var arr = [];
      if (this.formValidate.specType) {
        this.ManyAttrValue.forEach(function (val) {
          arr.push({
            addStock: val.addStock,
            id: val.id,
            version: 0
          });
        });
        (0, _store.stockAddApi)({
          attrValueList: arr,
          id: this.ManyAttrValue[0].productId
        }).then(function (res) {
          _this.$emit('sucess');
        });
      } else {
        this.OneattrValue.forEach(function (val) {
          arr.push({
            addStock: val.addStock,
            id: val.id,
            version: 0
          });
        });
        (0, _store.stockAddApi)({
          attrValueList: arr,
          id: this.OneattrValue[0].productId
        }).then(function (res) {
          _this.$emit('sucess');
        });
      }
    },
    getInit: function getInit() {
      var _this2 = this;
      if (this.formValidate.specType) {
        this.ManyAttrValue.forEach(function (val) {
          _this2.$set(val, 'addStock', 0);
        });
      } else {
        this.OneattrValue.forEach(function (val) {
          _this2.$set(val, 'addStock', 0);
        });
      }
    },
    // 详情
    getInfo: function getInfo(id) {
      var _this3 = this;
      this.fullscreenLoading = true;
      (0, _store.productDetailApi)(id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var info, imgs, imgss, manyAttr, tmp, tmpTab;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                // this.isAttr = true;
                info = res;
                _this3.formValidate = {
                  image: _this3.$selfUtil.setDomain(info.image),
                  sliderImage: info.sliderImage,
                  sliderImages: JSON.parse(info.sliderImage),
                  storeName: info.storeName,
                  keyword: info.keyword,
                  cateIds: info.cateId.split(','),
                  // 商品分类id
                  cateId: info.cateId,
                  // 商品分类id传值
                  unitName: info.unitName,
                  sort: info.sort,
                  isShow: info.isShow,
                  isBenefit: info.isBenefit,
                  isNew: info.isNew,
                  isGood: info.isGood,
                  isHot: info.isHot,
                  isBest: info.isBest,
                  tempId: info.tempId,
                  attr: info.attr,
                  attrValue: info.attrValue,
                  selectRule: info.selectRule,
                  isSub: info.isSub,
                  content: info.content ? _this3.$selfUtil.replaceImgSrcHttps(info.content) : '',
                  specType: info.specType,
                  id: info.id,
                  giveIntegral: info.giveIntegral,
                  ficti: info.ficti,
                  coupons: info.coupons,
                  couponIds: info.couponIds,
                  activity: info.activity ? info.activity : ['默认', '秒杀', '砍价', '拼团']
                };
                (0, _marketing.marketingSendApi)({
                  type: 3
                }).then(function (res) {
                  if (_this3.formValidate.couponIds !== null) {
                    var ids = _this3.formValidate.couponIds.toString();
                    var arr = res.list;
                    var obj = {};
                    for (var i in arr) {
                      obj[arr[i].id] = arr[i];
                    }
                    var strArr = ids.split(',');
                    var newArr = [];
                    var _iterator = _createForOfIteratorHelper(strArr),
                      _step;
                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var item = _step.value;
                        if (obj[item]) {
                          newArr.push(obj[item]);
                        }
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                    _this3.$set(_this3.formValidate, 'coupons', newArr); //在编辑回显时，让返回数据中的优惠券id，通过接口匹配显示,
                  }
                });
                imgs = JSON.parse(info.sliderImage);
                imgss = [];
                Object.keys(imgs).map(function (i) {
                  imgss.push(_this3.$selfUtil.setDomain(imgs[i]));
                });
                _this3.formValidate.sliderImages = [].concat(imgss);
                if (_this3.getFileType(_this3.formValidate.sliderImages[0]) == 'video') {
                  //如果返回数据轮播图的第一张是视频，就将其赋值给videoLink做渲染，同时将其在轮播图中删除
                  _this3.$set(_this3.formValidate, 'videoLink', _this3.formValidate.sliderImages[0]);
                  _this3.formValidate.sliderImages.splice(0, 1);
                }
                _this3.productGetRule();
                if (info.specType) {
                  _this3.formValidate.attr = info.attr.map(function (item) {
                    return {
                      attrName: item.attrName,
                      attrValue: item.attrValues.split(',')
                    };
                  });
                  _this3.ManyAttrValue = info.attrValue;
                  _this3.ManyAttrValue.forEach(function (val) {
                    val.image = _this3.$selfUtil.setDomain(val.image);
                    val.attrValue = JSON.parse(val.attrValue);
                    _this3.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
                  });
                  /***多规格商品如果被删除过sku，优先展示api返回的数据,否则会有没有删除的错觉***/
                  manyAttr = _this3.attrFormat(_this3.formValidate.attr);
                  if (manyAttr.length !== _this3.ManyAttrValue.length) {
                    _this3.$set(_this3, 'showAll', true);
                    _this3.isAttr = false;
                  } else {
                    _this3.isAttr = true;
                  }
                  /*******/
                  tmp = {};
                  tmpTab = {};
                  _this3.formValidate.attr.forEach(function (o, i) {
                    // tmp['value' + i] = { title: o.attrName }
                    // tmpTab['value' + i] = ''
                    tmp[o.attrName] = {
                      title: o.attrName
                    };
                    tmpTab[o.attrName] = '';
                  });

                  // 此处手动实现后台原本value0 value1的逻辑
                  _this3.formValidate.attrValue.forEach(function (item) {
                    for (var attrValueKey in item.attrValue) {
                      item[attrValueKey] = item.attrValue[attrValueKey];
                    }
                  });
                  _this3.manyTabTit = tmp;
                  _this3.manyTabDate = tmpTab;
                  _this3.formThead = Object.assign({}, _this3.formThead, tmp);
                } else {
                  _this3.OneattrValue = info.attrValue;
                  // this.formValidate.attr = [] //单规格商品规格设置为空
                }
                _this3.getInit();
                console.log(_this3.formValidate);
                _this3.fullscreenLoading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this3.fullscreenLoading = false;
        _this3.$message.error(res.message);
      });
    },
    // 获取商品属性模板；
    productGetRule: function productGetRule() {
      var _this4 = this;
      (0, _store.templateListApi)(this.tableFrom).then(function (res) {
        var list = res.list;
        for (var i = 0; i < list.length; i++) {
          list[i].ruleValue = JSON.parse(list[i].ruleValue);
        }
        _this4.ruleList = list;
      });
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    },
    watCh: function watCh(val) {
      var _this5 = this;
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.ManyAttrValue = this.attrFormat(val);
      this.ManyAttrValue.forEach(function (val, index) {
        var key = Object.values(val.attrValue).sort().join('/');
        if (_this5.attrInfo[key]) _this5.ManyAttrValue[index] = _this5.attrInfo[key];
      });
      this.attrInfo = [];
      this.ManyAttrValue.forEach(function (val) {
        _this5.attrInfo[Object.values(val.attrValue).sort().join('/')] = val;
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    attrFormat: function attrFormat(arr) {
      var data = [];
      var res = [];
      return format(arr);
      function format(arr) {
        if (arr.length > 1) {
          arr.forEach(function (v, i) {
            if (i === 0) data = arr[i]['attrValue'];
            var tmp = [];
            if (!data) return;
            data.forEach(function (vv) {
              arr[i + 1] && arr[i + 1]['attrValue'] && arr[i + 1]['attrValue'].forEach(function (g) {
                var rep2 = (i !== 0 ? '' : arr[i]['attrName'] + '_') + vv + '$&' + arr[i + 1]['attrName'] + '_' + g;
                tmp.push(rep2);
                if (i === arr.length - 2) {
                  var rep4 = {
                    image: '',
                    price: 0,
                    cost: 0,
                    otPrice: 0,
                    stock: 0,
                    barCode: '',
                    weight: 0,
                    volume: 0,
                    addStock: 0,
                    brokerage: 0,
                    brokerageTwo: 0,
                    brokerageThree: 0
                  };
                  rep2.split('$&').forEach(function (h, k) {
                    var rep3 = h.split('_');
                    if (!rep4['attrValue']) rep4['attrValue'] = {};
                    rep4['attrValue'][rep3[0]] = rep3.length > 1 ? rep3[1] : '';
                  });
                  for (var attrValueKey in rep4.attrValue) {
                    rep4[attrValueKey] = rep4.attrValue[attrValueKey];
                  }
                  res.push(rep4);
                }
              });
            });
            data = tmp.length ? tmp : [];
          });
        } else {
          var dataArr = [];
          arr.forEach(function (v, k) {
            v['attrValue'].forEach(function (vv, kk) {
              dataArr[kk] = v['attrName'] + '_' + vv;
              res[kk] = {
                image: '',
                price: 0,
                cost: 0,
                otPrice: 0,
                stock: 0,
                barCode: '',
                weight: 0,
                volume: 0,
                addStock: 0,
                brokerage: 0,
                brokerageTwo: 0,
                brokerageThree: 0,
                attrValue: _defineProperty({}, v['attrName'], vv)
              };
              for (var attrValueKey in res[kk].attrValue) {
                res[kk][attrValueKey] = res[kk].attrValue[attrValueKey];
              }
            });
          });
          data.push(dataArr.join('$&'));
        }
        return res;
      }
    }
  }
};